import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  getParam,
  postApproval,
  postInvoiceSap,
  getExcel,
  getId,
  deleteById,
  getChanges,
  getUsername,
  postChanges,
  rejectById,
} from "./reportHeaderAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  statusParam: [],
  reasonParam: [],
  approval: [],
  retNumber: null,
  keepData: false,
  dataExcel: null,
  stepParam: [],
  dataId: null,
  draftReturn: [],
};

export const fetchAll = createAsyncThunk(
  "reportHeader/fetchAll",
  async (payload) => {
    const response = await getAll(payload);
    return response.data;
  }
);

export const fetchReturnId = createAsyncThunk(
  "purchaseOrder/fetchReturnId",
  async (payload) => {
    const response = await getId(payload);
    return response.data;
  }
);

export const fetchStepParam = createAsyncThunk(
  "reportDetail/fetchStepParam",
  async (payload) => {
    const response = await getParam(payload);
    return response.data;
  }
);

export const fetchExcel = createAsyncThunk(
  "reportHeader/fetchExcel",
  async (payload) => {
    const response = await getExcel(payload);
    return response.dataExcel;
  }
);

export const fetchStatusParam = createAsyncThunk(
  "reportHeader/fetchStatusParam",
  async (payload) => {
    const response = await getParam(payload);
    return response.data;
  }
);

export const updateReasonParam = createAsyncThunk(
  "reportHeader/updateReasonParam",
  async (payload) => {
    return payload;
  }
);

export const fetchReasonParam = createAsyncThunk(
  "reportHeader/fetchReasonParam",
  async (payload) => {
    const response = await getParam(payload);
    return response.data;
  }
);

export const createApproval = createAsyncThunk(
  "reportHeader/createApproval",
  async ({ retNumber, payload }) => {
    const response = await postApproval(retNumber, payload);
    return response;
  }
);

export const createInvoice = createAsyncThunk(
  "reportHeader/createInvoice",
  async (retNumber) => {
    const response = await postInvoiceSap(retNumber);
    return response.data;
  }
);

export const removeById = createAsyncThunk(
  "userrole/removeById",
  async (id) => {
    const response = await deleteById(id);
    return response;
  }
);

export const postReject = createAsyncThunk(
  "reportHeader/postReject",
  async ({ params, id }) => {
    const response = await rejectById(params, id);
    return response;
  }
);


export const reportHeaderSlice = createSlice({
  name: "reportHeader",
  initialState,
  reducers: {
    resetData: (state) => initialState,
    setKeepData: (state) => {
      state.keepData = true;
    },
    setSelected: (state, action) => {
      state.selected = action.payload.approvalMaterial;
    },
    setDraftReturn: (state, action) => {
      state.draftReturn = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(fetchReturnId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchReturnId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data;
      })
      .addCase(fetchExcel.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchExcel.fulfilled, (state, action) => {
        state.loading = false;
        state.dataExcel = action.payload;
      })
      .addCase(fetchStatusParam.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStatusParam.fulfilled, (state, action) => {
        state.loading = false;
        state.statusParam = action.payload.data;
      })
      .addCase(updateReasonParam.fulfilled, (state, action) => {
        state.reasonParam = action.payload;
      })
      .addCase(fetchReasonParam.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchReasonParam.fulfilled, (state, action) => {
        state.loading = false;
        state.reasonParam = action.payload.data;
      })
      .addCase(createApproval.pending, (state) => {
        state.loading = true;
      })
      .addCase(createApproval.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createApproval.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(createInvoice.pending, (state) => {
        state.loading = true;
      })
      .addCase(createInvoice.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createInvoice.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(fetchStepParam.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStepParam.fulfilled, (state, action) => {
        state.loading = false;
        state.stepParam = action.payload.data;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(postReject.pending, (state) => {
        state.loading = true;
      })
      .addCase(postReject.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },

});

export const {
  resetData,
  setSelected,
  setKeepData,
  setDraftReturn,
} = reportHeaderSlice.actions;

export const selectData = (state) => state.reportHeader.data;
export const selectReturnId = (state) => state.reportHeader.dataId;
export const selectLoading = (state) => state.reportHeader.loading;
export const selectError = (state) => state.reportHeader.error;
export const selectPageNo = (state) => state.reportHeader.pageNo;
export const selectPageSize = (state) => state.reportHeader.pageSize;
export const selectTotalRecord = (state) => state.reportHeader.totalRecord;
export const selectSelected = (state) => state.reportHeader.selected;
export const selectStatusParam = (state) => state.reportHeader.statusParam;
export const selectReasonParam = (state) => state.reportHeader.reasonParam;
export const selectKeepData = (state) => state.reportHeader.keepData;
export const selectStepParam = (state) => state.reportDetail.stepParam;
export const selectDraftReturn = (state) => state.reportDetail.draftReturn;

export default reportHeaderSlice.reducer;
